import { render, staticRenderFns } from "./EntryDetailResume.vue?vue&type=template&id=53cd8526"
import script from "./EntryDetailResume.vue?vue&type=script&lang=js"
export * from "./EntryDetailResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports